export type ActiveSessionBrowserEventRoom = {
  name?: string;
  state?: unknown;
};

export type BuildActiveSessionBrowserEventLogInput = {
  eventName: string;
  isConnected: boolean;
  isRecording: boolean;
  room: ActiveSessionBrowserEventRoom;
  browserDiagnostics: Record<string, unknown>;
  extra?: Record<string, unknown>;
};

export function buildActiveSessionBrowserEventLog({
  eventName,
  isConnected,
  isRecording,
  room,
  browserDiagnostics,
  extra,
}: BuildActiveSessionBrowserEventLogInput): Record<string, unknown> | null {
  if (!isConnected && !isRecording) {
    return null;
  }

  return {
    eventName,
    isConnected,
    isRecording,
    roomName: room.name || null,
    roomState: room.state,
    ...browserDiagnostics,
    ...extra,
  };
}
